<template>
    <QrWrapper>
        <div class="md:grid grid-cols-12">
            <QrCard v-if="loaded" class="col-span-10 col-start-2 md:col-start-3 md:col-span-8 lg:col-start-3 lh:col-span-6">
                <div class="w-full h-1 bg-gray-400 relative mb-4">
                    <div class="bg-green-500 h-1 transition-all" :style="{
                        'width': width
                    }"/>

                    <div class="absolute -top-1 -left-0 bg-green-500 rounded-full h-3 w-3"/>

                    <div
                        class="absolute -top-1 left-[33%] rounded-full h-3 w-3"
                        :class="newQrCode.step >= 2 ? 'bg-green-500' : 'bg-gray-400'"
                    />

                    <div
                        class="absolute -top-1 left-[66%] rounded-full h-3 w-3"
                        :class="newQrCode.step >= 3 ? 'bg-green-500' : 'bg-gray-400'"
                    />

                    <div
                        class="absolute -top-1 -right-0 rounded-full h-3 w-3"
                        :class="newQrCode.step >= 4 ? 'bg-green-500' : 'bg-gray-400'"
                    />
                </div>

                <RouterView/>
            </QrCard>
        </div>
    </QrWrapper>
</template>

<script setup>
import QrCard from "@/components/application-ui/panels/QrCard.vue";
import TopMenu from "@/components/TopMenu.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import { storeToRefs } from "pinia";
import { useQrCodesStore } from "@/store/qrCodes.js";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import {useProductsStore} from "@/store/products.js";

const route = useRoute();
const router = useRouter();

const productsStore = useProductsStore();
const qrCodeStore = useQrCodesStore();
const { newQrCode, qrCode } = storeToRefs(qrCodeStore);

const loaded = ref(false)
const width = computed(() => {
    if (newQrCode.value.step === 1) {
        return '16.5%';
    }

    if (newQrCode.value.step === 2) {
        return '50%';
    }

    if (newQrCode.value.step === 2.5) {
        return '60%';
    }

    if (newQrCode.value.step === 3) {
        return '83.5%';
    }

    if (newQrCode.value.step === 4) {
        return '100%';
    }
});

onMounted(async () => {
    await productsStore.fetch();

    const routeName = route.name;
    const allowedRoutes = [
        'qr.create.product',
        'qr.create.type',
        'qr.create.homepage',
        'qr.create.design',
        'qr.create.order',
    ];

    if (! allowedRoutes.includes(routeName)) {
        await router.push({ name: 'qr.create.product' });
    }

    if (route.params.qrCode) {
        await qrCodeStore.fetchOne(route.params.qrCode)

        newQrCode.value.redirect_url = qrCode.value.redirect_url
        newQrCode.value.name = qrCode.value.name
        newQrCode.value.type = qrCode.value.type;
        newQrCode.value.product_id = qrCode.value.product.id;
        newQrCode.value.homepage_title = qrCode.value.homepage?.title;
        newQrCode.value.homepage_sub_title = qrCode.value.homepage?.sub_title;
    } else {
        qrCodeStore.resetNewQrCode();
    }

    loaded.value = true;
})
</script>
